import React, {useEffect, useState} from 'react';
import styled from '@emotion/styled'

const ButtonScrollWrapper = styled.button`

`

const ButtonScroll = ({children, targetRef, margin, startAtZero, lastRef, scrollGap})=>{
    const [buttonActive, setButtonActive] = useState(false)
    useEffect(
        ()=>{
            const checkAreaRef = ()=>{
                if(targetRef) {
                    let marginTargetRef = margin
                    if(!margin) {
                        marginTargetRef = 0;
                    }
                    const eventPositionY = {
                        start : targetRef.current.offsetTop + scrollGap,
                        end : targetRef.current.offsetTop + targetRef.current.offsetHeight + scrollGap + marginTargetRef - 1
                    }
                    if(startAtZero) {
                        if( window.scrollY < eventPositionY.end ) {
                            setButtonActive(true);
                        } else {
                            setButtonActive(false);
                        }
                    } else if (lastRef) {
                        if ( window.scrollY >= eventPositionY.start ) {
                            setButtonActive(true);
                        } else {
                            setButtonActive(false);
                        }
                    } else {
                        if ( window.scrollY >= eventPositionY.start && window.scrollY < eventPositionY.end ) {
                            setButtonActive(true);
                        } else {
                            setButtonActive(false);
                        }
                    }
                }
            }
            checkAreaRef();
            window.addEventListener("scroll", checkAreaRef)
            window.addEventListener("resize", checkAreaRef)
            return (
                ()=>{
                    window.removeEventListener("resize", checkAreaRef)
                    window.removeEventListener("scroll", checkAreaRef)
                }
                
            )
        }, [targetRef, startAtZero, margin, lastRef, scrollGap]
    )
    return(
        <ButtonScrollWrapper className={buttonActive?"on":""} onClick={()=>{
            window.scroll({
                top: targetRef.current.offsetTop + scrollGap,
                behavior: "smooth",
            })
        }}>
            {children}
        </ButtonScrollWrapper>
    )
}

export default ButtonScroll;